import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button } from 'reactstrap';
import UsersTable from '../Components/Tables/usersTable';
import UserModal from '../Components/Modals/userModal';
import * as userService from '../Services/userService';
import { hasEditingRole } from '../Services/utils';
import { ModalMode } from '../Helpers/enums';
import { SpinnerLoader } from '../Components/shared/spinnerLoader';
import useAuthStore from '../../../stores/authStore';
import useUsersStore from '../../../stores/usersStore';

const CompanyUsers = () => {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);

  const users = useUsersStore((state) => state.users);
  const isLoading = useUsersStore((state) => state.isLoading);
  const fetchUsers = useUsersStore((state) => state.fetchUsers);

  const [modalPurpose, setModalPurpose] = useState('');
  const [userToViewOrEdit, setUserToViewOrEdit] = useState({ roles: [] });
  const [showModal, setShowModal] = useState(false);

  const toggle = (editOrViewOrCreate, item) => {
    if (editOrViewOrCreate === 'create') {
      setModalPurpose(ModalMode.Create);
      setUserToViewOrEdit({ userRoles: [] });
    } else if (editOrViewOrCreate === 'edit') {
      setModalPurpose(ModalMode.Edit);
      setUserToViewOrEdit(item);
    } else if (editOrViewOrCreate === 'view') {
      setModalPurpose(ModalMode.View);
      setUserToViewOrEdit(item);
    } else {
    }

    setShowModal(!showModal);
  };

  const refreshUsers = () => {
    fetchUsers();
  };

  const handleValidUserSubmit = (values, event) => {
    if (!values.id || values.id === '') {
      userService
        .createUser(values)
        .then((response) => {
          refreshUsers();
        })
        .catch((error) => {
          // Handle error
        })
        .finally(() => {
          toggle('close', null);
        });
    } else {
      userService
        .updateUserFromList(values)
        .then((response) => {
          refreshUsers();
        })
        .finally(() => {
          toggle('close', null);
        });
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const canEdit = hasEditingRole(user);

  return (
    <Card className="card-default mb-1">
      <div className="card-header bg-gray-lighter text-bold">
        {t('settings.USERS_RECRUITERS')}
        {canEdit ? (
          <Button color="primary" className="float-right" onClick={() => toggle('create', null)}>
            <i className="icon-user-follow"></i> {t('common.ADD')}
          </Button>
        ) : (
          <span className="float-right text-warning">{t('settings.ONLY_ADMIN_OWNR_DESCRIPTION')}</span>
        )}
      </div>
      <div className="card-body">
        <div className="form-group">
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <UsersTable users={users} onItemClicked={toggle} onStatusRefresh={refreshUsers} hasEditingRole={canEdit} />
          )}
          <UserModal
            showModal={showModal}
            userToViewOrEdit={userToViewOrEdit}
            modalPurpose={modalPurpose}
            closeModal={() => toggle('close', null)}
            onHandleValidUserSubmit={handleValidUserSubmit}
          />
        </div>
      </div>
    </Card>
  );
};

export default CompanyUsers;
